import React from 'react';
import { Link } from 'react-router-dom';

interface AssignedAssessmentsProps {
  assignments: any[] | undefined;
  formatDate: (timestamp: number) => string;
}

export const AssignedAssessments: React.FC<AssignedAssessmentsProps> = ({ 
  assignments, 
  formatDate 
}) => {
  return (
    <section className="assignments-section" style={{ marginBottom: '3rem' }}>
      <h2 style={{ marginBottom: '1.5rem', fontSize: '1.8rem' }}>Assigned Assessments</h2>
      {assignments === undefined ? (
        <p>Loading assessments...</p>
      ) : assignments.length === 0 ? (
        <div style={{ padding: '2rem', textAlign: 'center', border: '1px dashed var(--border)', borderRadius: '8px', color: 'var(--muted-foreground)' }}>
          You have no active assessments assigned to you.
        </div>
      ) : (
        <div className="assignments-grid" style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', 
          gap: '1.5rem' 
        }}>
          {assignments.map((assignment) => (
            <div key={assignment._id} className="assignment-card" style={{ 
              padding: '1.5rem', 
              border: '1px solid var(--border)', 
              borderRadius: '8px',
              background: 'var(--card)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                  <h3 style={{ margin: 0, fontSize: '1.2rem' }}>{assignment.assessmentTitle}</h3>
                  <span style={{ 
                    fontSize: '0.8rem', 
                    padding: '0.2rem 0.5rem',
                    borderRadius: '4px',
                    background: assignment.status === 'completed' ? 'var(--success-muted)' : 'var(--info-muted)',
                    color: assignment.status === 'completed' ? 'var(--success)' : 'var(--info)',
                    textTransform: 'capitalize'
                  }}>
                    {assignment.status.replace('_', ' ')}
                  </span>
                </div>
                <p style={{ color: 'var(--muted-foreground)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
                  {assignment.deadline ? `Deadline: ${formatDate(assignment.deadline)}` : 'No deadline set'}
                </p>
              </div>
              
              <Link 
                to={`/assessments/${assignment._id}`}
                style={{ 
                  textDecoration: 'none', 
                  padding: '0.8rem', 
                  background: 'var(--primary)', 
                  color: 'white', 
                  borderRadius: '6px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  opacity: assignment.status === 'completed' ? 0.7 : 1
                }}
              >
                {assignment.status === 'completed' ? 'View Results' : 'Start Assessment'}
              </Link>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

